import classNames from 'classnames';
import Spinner from 'react-svg-spinner';

import * as Icons from '@/components/icons';
import { Link } from '@/components/link';

import { isLink } from '@/helpers/storyblok/is-link';

import './index.css';

delete Spinner.defaultProps;

const ICON_MAPPING = {
  phone: <Icons.Phone />,
  'arrow-right': <Icons.ArrowRight />,
  'arrow-top-right': <Icons.ArrowTopRight />,
  'chevron-right': <Icons.ChevronRight color={'var(--color)'} />,
  download: <Icons.Download />,
};

/**
 * @param {object} props - Props for the button.
 */
export const Button = ({
  as = 'button',
  link = null,
  theme = 'primary',
  height = 'normal',
  fontSize = 'normal',
  loading = null,
  leftIcon = null,
  rightIcon = null,
  fullWidth = false,
  children,
  dangerouslySetInnerHTML,
  disabled = false,
  ...rest
}) => {
  const El = isLink(link) ? Link : as;

  return (
    <div
      className={classNames(
        'button',

        `button--theme-${theme}`,
        `button--height-${height}`,
        `button--font-size-${fontSize}`,
        {
          ['button--has-left-icon']: leftIcon,
          ['button--has-right-icon']: rightIcon,
          ['button--disabled']: disabled,
          ['button--loading']: loading,
          ['button--full-width']: fullWidth,
        },
      )}
    >
      <div className="button__background"></div>

      <div className="button__content">
        {ICON_MAPPING[leftIcon] ? (
          <div className={classNames('button__icon', 'button__icon--left')}>
            {ICON_MAPPING[leftIcon]}
          </div>
        ) : null}

        <El
          className="button__text"
          link={El === Link ? link : null}
          disabled={El === 'button' ? disabled : undefined}
          {...rest}
          {...(children ? { children } : { dangerouslySetInnerHTML })}
        />

        {ICON_MAPPING[rightIcon] ? (
          <div className={classNames('button__icon', 'button__icon--right')}>
            {ICON_MAPPING[rightIcon]}
          </div>
        ) : null}

        {typeof loading === 'boolean' ? (
          <div className="button__spinner">
            <Spinner
              color="var(--color)"
              speed="fast"
              size="20"
              gap={4}
              thickness={3}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};
